import React from 'react';
import { Link } from 'react-router-dom';
import { 
  FaPhone, 
  FaWhatsapp, 
  FaEnvelope, 
  FaMapMarkerAlt,
  FaFacebook,
  FaInstagram,
  FaLinkedin
} from 'react-icons/fa';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { path: '/', label: 'Inicio' },
    { path: '/sobre-mi', label: 'Sobre Mí' },
    { path: '/servicios', label: 'Servicios' },
    { path: '/contacto', label: 'Contacto' }
  ];

  const services = [
    'Fisioterapia Traumatológica',
    'Fisioterapia Deportiva',
    'Rehabilitación Post-Quirúrgica',
    'Terapia Manual',
    'Electroneuroacupuntura (ENA)',
    'Punción Seca',
    'Presoterapia'
  ];

  const contactInfo = [
    {
      icon: <FaPhone />,
      text: '654 38 49 37',
      link: 'tel:+34654384937'
    },
    {
      icon: <FaWhatsapp />,
      text: 'WhatsApp',
      link: 'https://wa.me/34654384937'
    },
    {
      icon: <FaEnvelope />,
      text: 'javier.m.v.2001@gmail.com',
      link: 'mailto:javier.m.v.2001@gmail.com'
    },
    {
      icon: <FaMapMarkerAlt />,
      text: 'San Lorenzo de El Escorial - Madrid',
      link: 'https://maps.google.com'
    }
  ];

  const socialLinks = [
    {
      icon: <FaInstagram />,
      link: 'https://instagram.com/javimv_fisioterapia/',
      label: 'Instagram'
    },
    {
      icon: <FaLinkedin />,
      link: 'https://www.linkedin.com/in/javier-mu%C3%B1oz-velasco-369734282/',
      label: 'LinkedIn'
    }
  ];

  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="container">
          <div className="footer-grid">
            {/* Company Info */}
            <div className="footer-section">
              <h3 className="footer-brand">JMV - Fisioterapia</h3>
              <p>
                Tu bienestar es lo primero. Ofrezco tratamientos personalizados 
                para ayudarte a recuperar tu movilidad y mejorar tu calidad de vida.
              </p>
              <div className="social-links">
                {socialLinks.map((social, index) => (
                  <a
                    key={index}
                    href={social.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="social-link"
                    aria-label={social.label}
                  >
                    {social.icon}
                  </a>
                ))}
              </div>
            </div>

            {/* Quick Links */}
            <div className="footer-section">
              <h4>Enlaces Rápidos</h4>
              <ul className="footer-links">
                {quickLinks.map((link, index) => (
                  <li key={index}>
                    <Link to={link.path}>{link.label}</Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Services */}
            <div className="footer-section">
              <h4>Servicios</h4>
              <ul className="footer-links">
                {services.map((service, index) => (
                  <li key={index}>
                    <Link to="/servicios">{service}</Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Contact Info */}
            <div className="footer-section">
              <h4>Información de Contacto</h4>
              <div className="contact-links">
                {contactInfo.map((contact, index) => (
                  <a
                    key={index}
                    href={contact.link}
                    target={contact.link.startsWith('http') ? '_blank' : undefined}
                    rel={contact.link.startsWith('http') ? 'noopener noreferrer' : undefined}
                    className="contact-link"
                  >
                    <span className="contact-icon">{contact.icon}</span>
                    <span>{contact.text}</span>
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="footer-bottom">
        <div className="container">
          <div className="footer-bottom-content">
            <p>&copy; {currentYear} JMV - Fisioterapia. Todos los derechos reservados.</p>
            <div className="footer-bottom-links">
              <Link to="/privacidad">Política de Privacidad</Link>
              <a
                href="#cookies"
                onClick={(e) => { e.preventDefault(); window.cookieConsent?.openSettings?.(); }}
              >
                Preferencias de Cookies
              </a>
              <Link to="/terminos">Términos y Condiciones</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 